import { AfterViewInit, Component, OnDestroy, OnInit, ChangeDetectionStrategy, Injector, inject, signal } from '@angular/core'
import { form, required } from '@angular/forms/signals'
import { AsiakasService } from 'app/_angular/service/asiakas/asiakas.service'
import { DebugService } from 'app/_angular/service/debug.service'
import { KirjautunutKayttajaService } from 'app/_angular/service/kirjautunut-kayttaja.service'
import { arvonMuutokset, asetaArvo } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'
import { Asiakas } from 'app/_jaettu-lemonator/model/asiakas'
import { Observable, Subject, combineLatest } from 'rxjs'
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators'

@Component({
  templateUrl: './ajopaivakirja-container.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AjopaivakirjaContainerComponent implements OnInit, AfterViewInit, OnDestroy {
  kirjanpitajaOnDevaajaObservable: Observable<boolean>
  ulkopuolisetKulutUriObservable: Observable<string>
  ulkopuolisetKulutEncodedUriObservable: Observable<string>

  constructor(
    private _asiakasService: AsiakasService,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _debugService: DebugService,
  ) {}

  readonly selectedYear = signal<number>(undefined)

  yearRange = [2019, 2020, 2021, 2022, 2023, 2024, 2025]
  vuosi = form(signal<number>(0), polku => {
    required(polku)
  })
  readonly asiakas = signal<Asiakas>(undefined)
  private ngUnsubscribe: Subject<void> = new Subject<void>()
  private readonly _injector = inject(Injector)

  ngOnInit() {
    // Debug thingies
    this.kirjanpitajaOnDevaajaObservable = this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaObservable
    this.ulkopuolisetKulutUriObservable = combineLatest([this._asiakasService.nykyinenAsiakasAvainObservable, arvonMuutokset(this.vuosi, { injector: this._injector })]).pipe(
      map(([avainTiedot, vuosi]) => {
        if (avainTiedot?.avain) {
          if (vuosi === 2019) {
            return 'customers/' + avainTiedot.avain + '/customer-ajopaivakirja/' + avainTiedot.avain + '_' + vuosi
          }
          return 'customers/' + avainTiedot.avain + '/customer-ulkopuoliset-kulut/' + avainTiedot.avain + '_' + vuosi
        }
        return ''
      }),
    )
    this.ulkopuolisetKulutEncodedUriObservable = this.ulkopuolisetKulutUriObservable.pipe(
      map(uri => {
        return this._debugService.createFirestoreLinkLemonaid(uri)
      }),
    )

    this._asiakasService.nykyinenAsiakasObservable.pipe(distinctUntilChanged((a, b) => a?.avain === b?.avain)).subscribe(asiakas => {
      if (asiakas) {
        this.asiakas.set(asiakas)
      }
    })

    arvonMuutokset(this.vuosi, { injector: this._injector })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(selectedYear => {
        this.selectedYear.set(selectedYear)
      })
  }

  ngAfterViewInit() {
    asetaArvo(this.vuosi, this.yearRange[this.yearRange.length - 1])
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }
}
